import { create } from "zustand";
import { RoleStoreProps } from "./interface/role-store.interface";
import { getAllRoles } from "src/services/map-company-user.service";
import { orderSortingRole } from "src/entity/common/roles.enum";
import { Role } from "src/entity/map-company-user/user-in-company";

export const roleStore = create<RoleStoreProps>((set) => ({
  loading: false,
  data: null,
  error: null,
  getAllRoles: async () => {
    set(() => ({ loading: true }));
    try {
      const res = await getAllRoles();
      const rawData = res.data?.data || [];
      const sortingRoles = rawData.sort((a: Role, b: Role) => {
        return orderSortingRole.indexOf(a.roleName) - orderSortingRole.indexOf(b.roleName);
      });

      set(() => ({ loading: false, data: sortingRoles }));
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message, data: null }));
    }
  },
}));
